module.exports = {
  env: 'production',
  domain: ['admin-allerhub.allerganaesthetics.cn', 'pan-allerhub.allerganaesthetics.cn'],
  aegisId: 'akNqIsanjBcOOiYfZS',
  reportDomain: 'd.baike.qq.com',
  cosAppId: '1304685099',
  bucket: 'tsep-prod-1304685099',
  region: 'ap-guangzhou',
  mobileDomain: 'mb-allerhub.allerganaesthetics.cn',
};
